// extracted by mini-css-extract-plugin
export default {"wrapper":"sy","subscription":"ty","select_item":"uy","is_selected":"vy","otb":"wy","radio":"xy","first_row":"yy","prices":"zy","italic":"Ay","info_wrapper":"By","first_month":"Cy","separator":"Ey","checkmark":"Fy","bullets":"Gy","bullet":"Hy","checkmarkText":"Iy","button":"Jy","discountBadge":"Ky"};
    if(module.hot) {
      // 1714654886184
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  